import { render, staticRenderFns } from "./FccEventMain.vue?vue&type=template&id=0f48eba2&scoped=true&"
import script from "./FccEventMain.vue?vue&type=script&lang=js&"
export * from "./FccEventMain.vue?vue&type=script&lang=js&"
import style0 from "./FccEventMain.vue?vue&type=style&index=0&id=0f48eba2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f48eba2",
  null
  
)

export default component.exports